module.exports = __webpack_public_path__ + "img/duracion_largos.75d17d12.png";